import styled from '@emotion/styled/macro';

export default styled.h2`
	font-family: 'Pacifico';
	font-weight: normal;
	font-size: 42px;
	line-height: 0.71;
	color: var(--purple-brown);
`;
